import React from "react";
import { Instagram, Youtube, Linkedin } from "lucide-react";
import { ASSETS, SOCIALS } from "../data";
import { scrollToId } from "./Navbar";

const SOUNDCLOUD_ICON = (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden>
    <path d="M11.56 8.87V17h8.76c1.85 0 3.35-1.5 3.35-3.35 0-1.85-1.5-3.35-3.35-3.35-.36 0-.71.06-1.03.16-.31-2.98-2.83-5.3-5.89-5.3-.75 0-1.47.14-2.13.4-.26.1-.32.2-.32.4v2.91zM8.9 8.2c-.16 0-.29.13-.31.3l-.53 4.68.53 4.6c.02.17.15.3.31.3.16 0 .29-.13.31-.3l.61-4.6-.61-4.68c-.02-.17-.15-.3-.31-.3zm-2.02 1.5c-.16 0-.3.12-.32.29l-.44 3.18.44 3.09c.02.17.16.29.32.29.16 0 .29-.12.31-.29l.5-3.09-.5-3.18c-.02-.17-.15-.29-.31-.29zm-2.05.9c-.17 0-.3.12-.32.29l-.33 2.29.33 2.24c.02.17.15.29.32.29.16 0 .29-.12.31-.29l.39-2.24-.39-2.29c-.02-.17-.15-.29-.31-.29zm-2.02.55c-.17 0-.3.12-.32.3l-.27 1.73.27 1.7c.02.18.15.3.32.3.16 0 .29-.12.31-.3l.32-1.7-.32-1.73c-.02-.18-.15-.3-.31-.3z" />
  </svg>
);

const SOCIAL_ITEMS = [
  { icon: <Instagram size={20} />, href: SOCIALS.instagram, label: "Instagram", id: "instagram" },
  { icon: SOUNDCLOUD_ICON, href: SOCIALS.soundcloud, label: "SoundCloud", id: "soundcloud" },
  { icon: <Youtube size={20} />, href: SOCIALS.youtube, label: "YouTube", id: "youtube" },
  { icon: <Linkedin size={20} />, href: SOCIALS.linkedin, label: "LinkedIn", id: "linkedin" },
];

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-white/10 bg-black">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10">
        <button
          onClick={() => scrollToId("home")}
          data-testid="footer-logo"
          className="flex items-center gap-4 group"
        >
          <img
            src={ASSETS.wordmark}
            alt="TAO LUMIN"
            className="h-9 md:h-10 w-auto object-contain"
            style={{ filter: "invert(1)" }}
          />
        </button>

        <div className="flex items-center gap-3">
          {SOCIAL_ITEMS.map((s) => (
            <a
              key={s.id}
              data-testid={`footer-social-${s.id}`}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              className="h-11 w-11 flex items-center justify-center border border-white/15 text-[#F2F2F2]/70 hover:text-[#F2F2F2] hover:border-[#003399] hover:bg-[#003399]/20 transition-all duration-300"
            >
              {s.icon}
            </a>
          ))}
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <p className="text-[#F2F2F2]/40 text-xs uppercase tracking-[0.2em]">
          © {new Date().getFullYear()} Tao Lumin · Nassau, The Bahamas
        </p>
        <p className="text-[#F2F2F2]/40 text-xs uppercase tracking-[0.2em] max-w-md md:text-right">
          Facilitating a global evolution of the local music scene in The Bahamas.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
